import { WXShareOpstion, WXShare } from "./WXShare";
import { WXLogin } from "./WXLogin";

export class WXApi {
  static wxLogion(
    isSnsapiBase: boolean,
    checkRedirectUrl = "",
    callBack: Function
  ) {
    if (
      RegExp("^http.+?code=(.+?)&state=(.*?)$|&").exec(window.location.href)
    ) {
      WXLogin.checkUrl(callBack);
    } else {
      WXLogin.login(isSnsapiBase, checkRedirectUrl);
    }
  }

  static wxShareData(
    opstion: WXShareOpstion,
    success: Function,
    err:Function
  ) {
    WXShare.wxShareData(opstion, success, err);
  }
}
